
import { BOTTOM_SHEET_DRAG_THRESHOLD } from '@/constants/SHORTS_POPUP';

export default {
  i18nComponentKey: 'ReviewsShortsPopup.components.SpamReportDialog',
  name: 'SpamReportDialog',
  props: {
    reviewId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      dragStartY: null,
      dragCurrentY: null
    };
  },
  methods: {
    onTouchStart(event) {
      if (!event.touches) return;

      this.dragStartY = event.touches[0].clientY;
      this.dragCurrentY = event.touches[0].clientY;
    },
    onTouchMove(event) {
      if (!event.touches || this.dragStartY === null) return;

      this.dragCurrentY = event.touches[0].clientY;
    },
    onTouchEnd() {
      if (this.dragStartY === null || this.dragCurrentY === null) {
        this.resetDragState();
        return;
      }

      const dragDistance = this.dragCurrentY - this.dragStartY;
      if (dragDistance > BOTTOM_SHEET_DRAG_THRESHOLD) {
        this.$emit('close');
      }

      this.resetDragState();
    },
    resetDragState() {
      this.dragStartY = null;
      this.dragCurrentY = null;
    }
  }
};
